import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { CancelButton } from 'components/Profile/Documents/DeleteFileModal/styled';
import { InfoModal } from 'components/shared/Modal/Info';

import { ReactComponent as Error } from 'assets/icons/error.svg';

interface FailedFileProcessingModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const FailedFileProcessingModal: FC<FailedFileProcessingModalProps> = ({
	isOpen,
	onClose,
}) => {
	const { t: modalTranslate } = useTranslation(NamespacesList['modals']);

	return (
		<InfoModal
			isOpen={isOpen}
			image={<Error />}
			onClose={onClose}
			title={modalTranslate('uploadingFileIssue.title')}
			description={modalTranslate('uploadingFileIssue.description')}
			buttons={
				<CancelButton variant="contained" sx={{ width: '100%' }} color="error" onClick={onClose}>
					{modalTranslate('uploadingFileIssue.confirm')}
				</CancelButton>
			}
		/>
	);
};
